<template>
  <section
    v-if="enabled"
    :class="['checkin-check', { 'checkin-check--confirmed': confirmed }]"
  >
    <div class="checkin-check__content">
      <!-- icona solo da md in su -->
      <span class="checkin-check__icon">
        <vb-icon
          :name="confirmed ? 'check_circle' : 'city'"
          :size="20"
          :color="confirmed ? '06904d' : '065890'"
        />
      </span>
      <div class="checkin-check__text">
        <p class="checkin-check__title">
          {{ confirmed ? 'Grazie per il riscontro!' : "Hai già confermato l'orario d'arrivo con l'hotel?" }}
        </p>
        <p class="checkin-check__description">
          {{ confirmed
            ? "La tua conferma ti garantirà un arrivo più rapido e permetterà alla struttura di organizzare al meglio i tempi di attesa al check-in."
            : "Per garantirti un'accoglienza perfetta e zero attese al tuo arrivo, ti ricordiamo che è necessario concordare l'orario di check-in con la struttura." }}
        </p>
      </div>
    </div>
    <!-- vb_options non è reattivo: la key lo ricrea quando cambia lo stato -->
    <vb-button
      :key="`${confirmed}-${loading}`"
      class="checkin-check__button"
      :vb_options="{
        variant: 'info',
        disabled: confirmed || loading,
      }"
      @click="confirm_checkin"
    >
      Sì, ho già concordato l'orario di arrivo
    </vb-button>
  </section>
</template>

<script>
import { service_handler } from '@services'

export default {
  name: 'checkin-check',

  props: {
    // checkinCheck del voucher: { enabled, confirmed, confirmedAt }
    checkin_check: {
      type: Object,
      default: () => ({}),
    },
    // body della conferma, come per doubleCheck.confirm
    params: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    const { enabled = false, confirmed = false } = this.checkin_check || {}
    return {
      enabled,
      confirmed,
      loading: false,
    }
  },

  methods: {
    /**
     * Registra la dichiarazione del cliente. La chiamata è idempotente lato server.
     * 409 = prenotazione non più confermabile (non attiva o double check disattivato): il box sparisce.
     * Gli altri errori passano dalla modale automatica di service_handler.
     */
    confirm_checkin() {
      this.loading = true

      service_handler(
        'checkinCheck.confirm',
        this.params
      ).then(
        () => {
          this.confirmed = true
        },
        (error) => {
          this.enabled = !(error.response && error.response.status === 409)
        }
      ).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>

  .checkin-check {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    background-color: $selected;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 3rem;

    @include media-breakpoint-up(md) {
      flex-direction: row;
      align-items: center;
    }

    &__content {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      flex: 1;

      @include media-breakpoint-up(md) {
        padding-right: 15px;
      }
    }

    &__icon {
      display: none;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #deecff;

      @include media-breakpoint-up(md) {
        display: flex;
      }
    }

    &__text {
      display: flex;
      flex-direction: column;
      gap: 10px;

      @include media-breakpoint-up(md) {
        gap: 0;
      }
    }

    &__title {
      color: $primary;
      font-size: 18px;
      font-weight: $vb-font-weight-semibold;
      line-height: 23px;
      margin-bottom: 0;
    }

    &__description {
      font-size: 16px;
      line-height: 21px;
      margin-bottom: 0;
    }

    &__button {
      flex-shrink: 0;
      min-width: 130px;
      border-radius: 10px;
      font-size: 14px;
      font-weight: $vb-font-weight-semibold;
    }

    &--confirmed {
      .checkin-check__icon {
        background-color: #dfffde;
      }

      .checkin-check__title {
        color: $success;
      }
    }
  }

</style>
